import styled from 'styled-components';
import colors from '_colors.module.scss';
import { BdsGrid, BdsRadioGroup, BdsTable, BdsTypo } from 'blip-ds/dist/blip-ds-react';

export const ModalContent = styled(BdsGrid)`
  width: 600px;
`;

export const Subtitle = styled.div`
  bds-typo {
    color: ${colors.ContentDisable};
  }
`;

export const Table = styled(BdsTable)<{ $isLoading?: boolean }>`
  border: 1px solid var(--color-border-2, #0000001f);
  border-radius: 16px;
  overflow: hidden;
  ${({ $isLoading }) =>
    $isLoading &&
    `
    pointer-events: none;
    opacity: 0.6;
    cursor: not-allowed;
  `}
`;

export const RadioGroup = styled(BdsRadioGroup)`
  display: contents;
`;

export const GhostText = styled(BdsTypo)`
  color: ${colors.ContentDisable};
`;

export const DocumentNameContainer = styled(BdsGrid)`
  max-width: 216px;
`;

export const TruncatedDocumentName = styled(BdsTypo)`
  max-width: 216px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
